<template>
  <div :class="styleForPDF ? 'table-pdf-format' : 'height100'" id="table-pdf-format">
    <div class="main-wrapper height100">
      <div class="users-block">
        <div class="copy-element-box" v-if="selectedCopyDay && isCopyMode">
          <div
            class="copy-element-line"
            :style="`backgroundColor:${selectedCopyDay.shiftPositions.color ? selectedCopyDay.shiftPositions.color : 'white'};`"
          ></div>
          <div>{{ 'Shift Position' | i18n }}: {{ selectedCopyDay.shiftPositions.abbreviations || selectedCopyDay.shiftPositions.name }}</div>
          <div>{{ 'Absence' | i18n }}: {{ formatMessage(selectedCopyDay.shiftDetails.absence) | i18n }}</div>
          <div>{{ 'Remuneration information' | i18n }}: {{ formatMessage(selectedCopyDay.shiftDetails.payInformation) }}</div>
          <div>{{ 'Comment' | i18n }}: {{ formatMessage(selectedCopyDay.shiftDetails.comment) }}</div>
        </div>
        <div v-for="user in shift.users" :key="user.id" class="user-line">
          <div>
            {{ user.name }}
            <div v-if="user.notFromTeam" class="not-from-team">({{ 'Employee not from the team' | i18n }})</div>
          </div>
        </div>
      </div>
      <div class="shift-wrapper height100">
        <div class="shift-block height100">
          <div
            v-for="column in shift.columns"
            :key="column.date"
            :class="`column-block ${shidtPositionExist(column) ? 'big-block' : 'small-block'} ${
              moment(column.date).format('ddd') === 'Sun' ? 'is-sunday' : ''
            }`"
          >
            <div
              :class="`date-block ${moment(column.date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') ? 'active-text' : ''}`"
              @click="selectDate(column.shift, column.date)"
            >
              <div class="date-number">{{ moment(column.date).format('D') }}</div>
              <div class="date-name">{{ moment(column.date).format('ddd') | i18n }}</div>
            </div>
            <div class="shift-cell-date" :style="`background: ${getLableColor(column.shift)}`">
              <div class="cell-status">
                {{ `${column.shift}` | i18n }}
              </div>
            </div>
            <div
              v-for="u in shift.users"
              :key="`${column.date}${u.id}`"
              :class="`${column.shiftPositions[u.id] ? 'shift-cell' : 'shift-cell-disabled'}`"
              @click="isCopyMode ? (selectedCopyDay ? selectPasteDay(column, u) : selectCopyDay(column, u)) : selectCell(column, u)"
            >
              <div
                :class="'shift-cell'"
                style="width: 100%; cursor: pointer"
                v-if="column.shift === SHIFTS.OFF_SHIFT && !(column.shiftPositions[u.id] && column.shiftPositions[u.id].name)"
              ></div>
              <div
                v-else-if="
                  (column.shiftPositions[u.id] && column.shiftPositions[u.id].name) ||
                  (column.shiftDetails[u.id] && Object.keys(column.shiftDetails[u.id]).length)
                "
                :class="`shift-position-box ${column.isPasted[u.id] ? 'pasted-border' : ''}`"
              >
                <div class="shift-position-details">
                  <div v-if="column.shiftPositions[u.id]">Shift Position: {{ column.shiftPositions[u.id].name }}</div>
                  <span v-if="column.shiftDetails[u.id]">
                    <div>Working Hours: {{ formatMessage(column.shiftDetails[u.id].workingHours) }}</div>
                    <div>Absence: {{ $translate(formatMessage(column.shiftDetails[u.id].absence)) }}</div>
                    <div>Remuneration information: {{ formatMessage(column.shiftDetails[u.id].payInformation) }}</div>
                    <div>Comment: {{ formatMessage(column.shiftDetails[u.id].comment) }}</div>
                  </span>
                </div>
                <div class="position-color" :style="`backgroundColor:${getCellColor(column, u)};`">
                  <div class="shift-position-content">
                    <div class="shift-position-name">
                      <div class="icon-small-wrapper"><img :src="worker" class="icon-small" /></div>
                      <span v-if="column.shiftPositions[u.id] && !isNotPresent(column, u)">
                        {{ column.shiftPositions[u.id].abbreviations || column.shiftPositions[u.id].name }}
                      </span>
                      <span v-else>-</span>
                    </div>
                    <div v-if="column.shiftDetails[u.id] && Object.keys(column.shiftDetails[u.id]).length">
                      <div class="shift-position-name">
                        <div class="icon-small-wrapper"><img :src="clock" class="icon-small" /></div>
                        {{ column.shiftDetails[u.id].workingHours ? column.shiftDetails[u.id].workingHours : '-' }}
                      </div>
                      <div class="shift-position-name">
                        <div class="icon-small-wrapper"><img :src="plan" class="icon-small" /></div>
                        {{ column.shiftDetails[u.id].absence ? $translate(`${column.shiftDetails[u.id].absence}_SHORT`) : '-' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="cell-status-disabled"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import { SHIFTS, ABSENCE_IS_NOT_PRESENT } from '../../../../../../../constants';
import worker from '../../../../assets/icons/worker.svg';
import plan from '../../../../assets/icons/plan.svg';
import clock from '../../../../assets/icons/clock.svg';

export default {
  title: 'ShiftbaseTable',
  props: {
    userLineSize: {
      type: Number,
      default: 0,
    },
    isCopyMode: {
      type: Boolean,
    },
    styleForPDF: {
      type: Boolean,
    },
    selectedCopyDay: {
      type: Object,
      default: () => ({}),
    },
    selectPasteDay: {
      type: Function,
      default: () => {},
    },
    selectCopyDay: {
      type: Function,
      default: () => {},
    },
    shift: {
      type: Object,
      default: () => {},
    },
    shiftColors: {
      type: Object,
      default: () => {},
    },
    absenceColors: {
      type: Object,
      default: () => {},
    },
    selectCell: {
      type: Function,
      default: () => {},
    },
    selectDate: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      SHIFTS,
      moment,
      worker,
      plan,
      clock,
    };
  },
  methods: {
    isNotPresent(column, u) {
      if (column && u && column.shiftDetails && column.shiftDetails[u.id] && column.shiftDetails[u.id].absence) {
        const a = column.shiftDetails[u.id].absence;
        if (ABSENCE_IS_NOT_PRESENT.includes(a)) {
          return true;
        }
      }
      return false;
    },
    formatMessage(m) {
      return m ? m : ' -';
    },
    shidtPositionExist(column) {
      let exist = false;
      Object.values(column.shiftPositions).map((v) => {
        if (v && v.id) {
          exist = true;
        }
      });
      return exist;
    },
    getLableColor(name) {
      return this.shiftColors && this.shiftColors[name] ? this.shiftColors[name] : 'white';
    },
    getCellColor(column, u) {
      if (this.isNotPresent(column, u)) {
        const absence = column.shiftDetails[u.id] && column.shiftDetails[u.id].absence ? column.shiftDetails[u.id].absence : '';
        const color = this.absenceColors && this.absenceColors[absence] ? this.absenceColors[absence] : false;
        return color || 'white';
      } else {
        return column.shiftPositions[u.id] && column.shiftPositions[u.id].color ? column.shiftPositions[u.id].color : 'white';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$user-width: 200px;
$cell-small-width: 80px;
$cell-big-width: 80px;
$cell-height: 80px;

.btn-warning {
  color: white !important;
}

::v-deep .tooltip-inner {
  white-space: pre-line;
  text-align: left;
  min-width: 350px;
}

.height100 {
  height: 100%;
}
.total-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.alert-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  text-align: center;
}

.shift-block {
  display: flex;
  flex-direction: row;
  overflow: scroll;
  min-height: calc(100vh - 190px);
}

.shift-wrapper {
  padding-left: $user-width;
}

.column-block {
  border-right: 1px solid rgb(244, 242, 246);
  min-height: 100%;
}

.small-block {
  min-width: $cell-small-width;
}

.big-block {
  min-width: $cell-big-width;
}

.main-wrapper {
  position: relative;
}

.users-block {
  min-width: $user-width;
  width: $user-width;
  position: absolute;
  padding-top: 140px;
  box-shadow: 6px 0px 7px -8px rgba(34, 60, 80, 0.6);
  height: 100%;
  padding-right: 10px;
}

.user-line {
  height: $cell-height;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f4f2f6;
  overflow: hidden;
  padding-left: 10px;
  white-space: nowrap;
}

.date-block {
  height: 80px;
  padding-left: 5px;
  border-bottom: 1px solid #f4f2f6;
  cursor: pointer;
}

.date-number {
  font-size: 22px;
  color: rgb(66, 68, 72);
}

.date-name {
  font-size: 14px;
  color: rgb(168, 173, 187);
}

.active-text {
  div {
    color: #2260ff !important;
  }
}

.shift-cell {
  display: flex;
  align-items: center;
  height: $cell-height;
  border-bottom: 1px solid #f4f2f6;
}

.shift-cell-date {
  padding: 5px;
  display: flex;
  align-items: center;
  height: 60px;
  border-bottom: 1px solid #f4f2f6;
  justify-content: center;
  color: white;
}

.shift-cell-disabled {
  display: flex;
  align-items: center;
  height: $cell-height;
  border-bottom: 1px solid #f4f2f6;
}

// .shift-cell:hover {
//   border-radius: 15px;
//   background: #f4f2f6;
// }

.cell-status {
  overflow: hidden;
  white-space: nowrap;
}

.shift-position-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.shift-position-name {
  white-space: nowrap;
  display: flex;
  align-content: center;
}

.cell-status-disabled {
  background: #c7c7c7;
  border-radius: 8px;
  opacity: 0.3;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.cell-status-color {
  width: 7px;
  height: 7px;
  border-radius: 7px;
  margin-right: 3px;
}

.not-from-team {
  color: #c7c7c7;
  font-size: 12px;
}

.position-color {
  width: 100%;
  height: 100%;
  padding: 0 0 0 5px;
  cursor: pointer;
}

.shift-position-content {
  width: 100%;
  height: 100%;
  // border-radius: 8px;
  padding: 0 5px;
}

.shift-cell:hover,
.cell-status-disabled:hover,
.date-block:hover {
  box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.2);
  border-radius: 8px;
}

.icon-small-wrapper {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}
.icon-small {
  height: 15px;
  width: 15px;
  margin-right: 10px;
}

.is-sunday {
  border-right: 3px solid #6b6b6b;
}

.copy-element-box {
  position: absolute;
  top: 0;
  width: 100%;
  padding-right: 5px;
  height: 145px;
  overflow: scroll;
  padding-left: 8px;
}

.copy-element-line {
  position: absolute;
  left: 0px;
  top: 0;
  width: 5px;
  height: 145px;
}

.pasted-border {
  outline: 3px solid #3996fb;
}

.shift-position-details {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 190px;
  opacity: 0;
  word-break: break-word;
  background: white;
  box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.2);
  border-radius: 8px;
  padding: 5px;
}
.shift-cell:hover .shift-position-details {
  opacity: 1;
  z-index: 100;
}

.table-pdf-format {
  height: 794px !important;
  font-size: 10px !important;
  width: 1125px !important;
  display: flex;
  padding: 20px 0px;
  flex-direction: column;

  .date-block {
    padding: 0px;
    padding-left: 5px;
  }
  .column-block {
    min-width: 31.5px;
  }
  .cell-status {
    padding: 0px;
  }
  .date-name {
    font-size: 7px;
  }
  .date-number {
    font-size: 10px;
  }
  .users-block {
    padding-top: 50px;
    width: 115px;
    min-width: 115px;
  }
  .date-block {
    height: 30px;
  }
  .is-sunday {
    border-right: 1px solid #6b6b6b;
  }
  .user-line {
    height: 46px;
  }
  .shift-cell,
  .shift-cell-disabled {
    height: 46px;
  }
  .cell-status {
    font-size: 6px;
  }
  .shift-cell-date {
    height: 20px;
  }
  .icon-small-wrapper {
    display: none;
  }
  .shift-wrapper {
    padding-left: 115px;
  }
  .shift-position-content {
    padding: 0;
  }
}
</style>
